/* Applies Shopify discount codes through the Ajax Cart API and refreshes the drawer. */
document.addEventListener('submit', async (event) => {
  if (event.target?.id !== 'NtCartDiscountForm') return;
  event.preventDefault();

  const form = event.target;
  const input = form.querySelector('#NtCartDiscountCode');
  const button = form.querySelector('button[type="submit"]');
  const feedback = form.querySelector('.nt-cart__discount-feedback');
  const code = input?.value.trim();
  if (!code) return;

  button.disabled = true;
  feedback.textContent = 'Aplicando código…';

  try {
    const response = await fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        discount: code,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    });
    const cart = await response.json();
    if (!response.ok || cart.status) throw new Error(cart.description || cart.message || 'No se pudo aplicar el código.');

    const drawer = document.querySelector('cart-drawer');
    let drawerSection = cart.sections?.['cart-drawer'];
    if (!drawerSection) {
      try {
        const secRes = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`);
        if (secRes.ok) drawerSection = await secRes.text();
      } catch (_) {}
    }
    if (drawer && drawerSection) {
      const parsed = new DOMParser().parseFromString(drawerSection, 'text/html');
      const updated = parsed.querySelector('#CartDrawer');
      const current = drawer.querySelector('#CartDrawer');
      if (updated && current) {
        current.innerHTML = updated.innerHTML;
        drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
      }
    }
    let iconSection = cart.sections?.['cart-icon-bubble'];
    if (!iconSection) {
      try {
        const iconRes = await fetch(`${window.routes.cart_url}?section_id=cart-icon-bubble`);
        if (iconRes.ok) iconSection = await iconRes.text();
      } catch (_) {}
    }
    if (iconSection) {
      const parsed = new DOMParser().parseFromString(iconSection, 'text/html');
      const updated = parsed.querySelector('#cart-icon-bubble');
      const currentIcon = document.querySelector('#cart-icon-bubble');
      if (updated && currentIcon) currentIcon.innerHTML = updated.innerHTML;
    }

    const currentFeedback = document.querySelector('#NtCartDiscountForm .nt-cart__discount-feedback');
    const currentInput = document.querySelector('#NtCartDiscountCode');
    if (currentInput) currentInput.value = code;
    if (currentFeedback) {
      currentFeedback.textContent = 'Código enviado. Si cumple las condiciones, verás el descuento en el subtotal o al pagar.';
    }
  } catch (error) {
    feedback.textContent = error.message || 'No se pudo aplicar el código. Inténtalo de nuevo.';
  } finally {
    const currentButton = document.querySelector('#NtCartDiscountForm button[type="submit"]');
    if (currentButton) currentButton.disabled = false;
  }
});

/* A real five-minute cart window: when it ends, the Ajax cart is cleared. */
(() => {
  const key = 'newtrend_cart_expires_at_v1';
  const duration = 5 * 60 * 1000;
  let fallbackDeadline = null;
  let clearing = false;

  const readDeadline = () => {
    try { return Number(sessionStorage.getItem(key)) || fallbackDeadline; }
    catch (_) { return fallbackDeadline; }
  };
  const saveDeadline = (value) => {
    fallbackDeadline = value;
    try { sessionStorage.setItem(key, String(value)); } catch (_) {}
  };
  const resetDeadline = () => {
    fallbackDeadline = null;
    try { sessionStorage.removeItem(key); } catch (_) {}
  };

  async function clearExpiredCart(drawer) {
    if (clearing) return;
    clearing = true;
    try {
      const response = await fetch(`${window.routes.cart_url}/clear.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });
      const cart = await response.json();
      if (!response.ok || cart.status) throw new Error('No se pudo vaciar el carrito.');

      let updatedDrawerHtml = cart.sections?.['cart-drawer'];
      if (!updatedDrawerHtml) {
        try {
          const secRes = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`);
          if (secRes.ok) updatedDrawerHtml = await secRes.text();
        } catch (_) {}
      }
      if (updatedDrawerHtml) {
        const parsed = new DOMParser().parseFromString(updatedDrawerHtml, 'text/html');
        const updated = parsed.querySelector('#CartDrawer');
        const current = drawer.querySelector('#CartDrawer');
        if (updated && current) {
          current.innerHTML = updated.innerHTML;
          drawer.classList.add('is-empty');
          drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
          const emptyContent = drawer.querySelector('.cart-drawer__empty-content');
          if (emptyContent) {
            const note = document.createElement('p');
            note.className = 'nt-cart__expired-note';
            note.textContent = 'Se cumplieron los 5 minutos y el carrito se vació.';
            emptyContent.querySelector('.cart__empty-text')?.after(note);
          }
        }
      }
      let updatedIconHtml = cart.sections?.['cart-icon-bubble'];
      if (!updatedIconHtml) {
        try {
          const iconRes = await fetch(`${window.routes.cart_url}?section_id=cart-icon-bubble`);
          if (iconRes.ok) updatedIconHtml = await iconRes.text();
        } catch (_) {}
      }
      if (updatedIconHtml) {
        const parsed = new DOMParser().parseFromString(updatedIconHtml, 'text/html');
        const updated = parsed.querySelector('#cart-icon-bubble');
        const current = document.querySelector('#cart-icon-bubble');
        if (updated && current) current.innerHTML = updated.innerHTML;
      }
      resetDeadline();
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nt-cart-timer', cartData: cart });
      }
    } catch (error) {
      const timer = drawer.querySelector('[data-nt-cart-timer]');
      if (timer) timer.textContent = 'No se pudo actualizar el carrito. Inténtalo de nuevo.';
      saveDeadline(Date.now() + 30000);
    } finally {
      clearing = false;
    }
  }

  function tick() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const hasItems = Boolean(drawer.querySelector('#NtCartDiscountForm'));
    if (!hasItems) { resetDeadline(); return; }

    let deadline = readDeadline();
    if (!deadline) {
      if (!drawer.classList.contains('active')) return;
      deadline = Date.now() + duration;
      saveDeadline(deadline);
    }

    const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    const display = drawer.querySelector('[data-nt-cart-time]');
    if (display) {
      display.textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
    }
    if (seconds === 0) clearExpiredCart(drawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { tick(); setInterval(tick, 1000); }, { once: true });
  } else {
    tick();
    setInterval(tick, 1000);
  }
})();


/* Celebrate the first qualifying drawer view; reset after the cart falls below the goal. */
(() => {
  const key = 'newtrend_free_shipping_celebrated_v1';
  const colors = ['#d71920', '#020811', '#2c9b67', '#f5be45', '#70b7cf', '#ffffff'];
  let celebrated = false;

  try { celebrated = sessionStorage.getItem(key) === '1'; } catch (_) {}

  function remember(value) {
    celebrated = value;
    try {
      if (value) sessionStorage.setItem(key, '1');
      else sessionStorage.removeItem(key);
    } catch (_) {}
  }

  function celebrate(drawer) {
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    const inner = drawer.querySelector('.nt-cart');
    if (!inner) return;

    inner.querySelector('.nt-cart__confetti')?.remove();
    const layer = document.createElement('div');
    layer.className = 'nt-cart__confetti';
    layer.setAttribute('aria-hidden', 'true');

    for (let i = 0; i < 44; i += 1) {
      const piece = document.createElement('span');
      piece.className = 'nt-cart__confetti-piece';
      piece.style.setProperty('--nt-confetti-x', (6 + Math.random() * 88) + '%');
      piece.style.setProperty('--nt-confetti-size', (5 + Math.random() * 5) + 'px');
      piece.style.setProperty('--nt-confetti-color', colors[i % colors.length]);
      piece.style.setProperty('--nt-confetti-drift', Math.round((Math.random() - .5) * 170) + 'px');
      piece.style.setProperty('--nt-confetti-spin', Math.round(360 + Math.random() * 720) + 'deg');
      piece.style.setProperty('--nt-confetti-delay', (Math.random() * .35).toFixed(2) + 's');
      piece.style.setProperty('--nt-confetti-duration', (1.6 + Math.random() * .8).toFixed(2) + 's');
      layer.appendChild(piece);
    }

    inner.appendChild(layer);
    window.setTimeout(() => layer.remove(), 3100);
  }

  function check(drawer) {
    const unlocked = Boolean(drawer.querySelector('.nt-cart__shipping.is-unlocked'));
    if (!unlocked) {
      if (celebrated) remember(false);
      return;
    }
    if (!drawer.classList.contains('active') || celebrated) return;
    remember(true);
    celebrate(drawer);
  }

  function init() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const observer = new MutationObserver(() => check(drawer));
    observer.observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    check(drawer);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
